import { render, staticRenderFns } from "./goods-top-list.vue?vue&type=template&id=02531aaf&scoped=true&"
import script from "./goods-top-list.vue?vue&type=script&lang=js&"
export * from "./goods-top-list.vue?vue&type=script&lang=js&"
import style0 from "./goods-top-list.vue?vue&type=style&index=0&id=02531aaf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02531aaf",
  null
  
)

export default component.exports